import { useContext, useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { AuthSessionContext } from '@/features/auth/session'
import { startRealtimeEvents } from '@/lib/realtime-events'

export function RealtimeEvents() {
  const queryClient = useQueryClient()
  const session = useContext(AuthSessionContext)

  useEffect(() => {
    if (session?.status !== 'authenticated') {
      return undefined
    }

    return startRealtimeEvents({
      queryClient,
      onUnavailable: () => {
        queryClient.invalidateQueries({ queryKey: ['notifications'] })
      },
    })
  }, [queryClient, session?.status])

  return null
}
